import { defineEffect } from '../../../core/effect';
import { spsummoningSpec } from '../fx/spsummoning';

/** リンク召喚の **effect**: 特殊召喚の軽い召喚バンク（今は全状況で同じ見せ方。組み立ては `../fx/spsummoning.js`） */
export default defineEffect({ situation: 'spsummoning_link', role: 'effect', ...spsummoningSpec('spsummoning_link') }, 'spsummoning_link_effect.js');
